import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const CertificateFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const certificateTypes = [
    { value: 'all', label: 'All Types' },
    { value: 'gas', label: 'Gas Safety Certificate' },
    { value: 'epc', label: 'Energy Performance Certificate' },
    { value: 'eicr', label: 'Electrical Installation Certificate' },
    { value: 'legionella', label: 'Legionella Risk Assessment' },
    { value: 'smoke', label: 'Smoke Alarm Certificate' },
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'expired', label: 'Expired (0-14 days)' },
    { value: 'expiring', label: 'Expiring Soon (15-30 days)' },
    { value: 'valid', label: 'Valid (31+ days)' },
  ];

  const contractorOptions = [
    { value: 'all', label: 'All Contractors' },
    { value: 'C001', label: 'ABC Gas Services' },
    { value: 'C002', label: 'SafeHome Electrical' },
    { value: 'C003', label: 'EcoEnergy Assessors' },
    { value: 'C004', label: 'WaterSafe Ltd' },
  ];

  const hasActiveFilters = 
    filters?.type !== 'all' || 
    filters?.status !== 'all' || 
    filters?.contractor !== 'all' || 
    filters?.search !== '';

  return (
    <div className="card mb-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">Filter Certificates</h3>
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="flex items-center gap-2 text-sm text-accent hover:underline font-caption"
          >
            <Icon name="X" size={16} />
            Clear Filters
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search by Property ID or Address"
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          placeholder="Select certificate type"
          options={certificateTypes}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
        />

        <Select
          placeholder="Select status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          placeholder="Select contractor"
          options={contractorOptions}
          value={filters?.contractor}
          onChange={(value) => onFilterChange('contractor', value)}
        />
      </div>
    </div>
  );
};

export default CertificateFilters;